import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export const HelpCTA = () => {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4" data-id="element-53">
      <div className="container mx-auto" data-id="element-54">
        <button className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition-colors duration-150 shadow-sm" onClick={() => console.log('Open DPO chat')} data-id="element-55">
          <MessageCircleIcon size={20} data-id="element-56" />
          <span data-id="element-57">Need help staying compliant? Ask a DPO 💬</span>
        </button>
      </div>
    </div>;
};